export * from "./SpinnerComponent";
